function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.503 5.318c0 2.584-6.085 8.097-7.736 10.569a8.978 8.978 0 00-1.517 5.005c0 5.03 4.133 9.108 9.232 9.108 5.098 0 9.231-4.078 9.231-9.108 0-3.287-1.764-6.166-4.409-7.769 1.027 1.709 1.85 3.106 1.59 4.455-.317 1.646-1.578 2.457-3.376 2.457-1.8 0-3.258-1.44-3.258-3.215 0-2.992 3.792-4.569 3.792-8.602 0-3.915-2.799-7.184-6.53-7.968 0 0 2.981 1.464 2.981 5.068z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "6",
  y: "0",
  width: "19",
  height: "30"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.503 5.318c0 2.584-6.085 8.097-7.736 10.569a8.978 8.978 0 00-1.517 5.005c0 5.03 4.133 9.108 9.232 9.108 5.098 0 9.231-4.078 9.231-9.108 0-3.287-1.764-6.166-4.409-7.769 1.027 1.709 1.85 3.106 1.59 4.455-.317 1.646-1.578 2.457-3.376 2.457-1.8 0-3.258-1.44-3.258-3.215 0-2.992 3.792-4.569 3.792-8.602 0-3.915-2.799-7.184-6.53-7.968 0 0 2.981 1.464 2.981 5.068z",
  fill: "currentColor"
}))));